export enum DialogStandardFocus {
  CANCEL = 'Cancel',
  CONFIRM = 'Confirm',
  CLOSED = 'Closed'
}
